module.exports = __webpack_public_path__ + "WebComponentsIcons.c287b9821fd5610bd36f.woff";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.woff?gedxeo
// module id = ../../../../../external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.woff?gedxeo
// module chunks = styles